import React from 'react';
import WarrantyOptionsSummary from './WarrantyOptionsSummary';
const BapWarrantyOptions = (props) => React.createElement(WarrantyOptionsSummary, { ...props });
export default BapWarrantyOptions;
